let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("89JNM")).then(() => parcelRequire('bYd6G'));